import type { FC } from 'react'
import { Stack, Text, Center, Box } from 'components'
import { IconUserPlus } from '@tabler/icons-react'
import { useArcTranslation } from 'hooks'

export const EmptyAssignedStudents: FC = () => {
  const { t } = useArcTranslation()

  return (
    <Center sx={{ flex: 1 }}>
      <Stack align="center" spacing="sm">
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconUserPlus size={24} color="#999" stroke={1.5} />
        </Box>
        <Text size="sm" color="dimmed" ta="center" maw={320} lh={1.4}>
          {t('assign_project.empty_students_message')}
        </Text>
      </Stack>
    </Center>
  )
}
